import React from "react";
import SegmentPanel from "../SegmentPanel/SegmentPanel";
import ConditionGroup from "../ConditionGroup/ConditionGroup";
import { BaseCondition } from "@tiny/api";
import { useEditSegmentView } from "../EditSegment.context";
import { Box, CircularProgress } from "@mui/material";

const attributesTypes: NonNullable<BaseCondition["attributeType"]>[] = [
  "AUDIENCE",
];

function AudiencesPanel() {
  const { isSegmentLoading } = useEditSegmentView();
  return (
    <SegmentPanel title="Audience">
      {isSegmentLoading ? (
        <Box
          width="100%"
          height="100px"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <ConditionGroup
          prefixName="conditions.0"
          index={0}
          hideDivider
          attributesTypes={attributesTypes}
          maxConditions={1}
          minConditions={1}
          hideAddConditionsAtMax
        />
      )}
    </SegmentPanel>
  );
}

export default AudiencesPanel;
